export enum AutomationEvent {
  APPOINTMENT_CREATED = 'appointmentCreated',
  APPOINTMENT_CHECKED_IN = 'appointmentCheckedIn',
  INTAKE_COMPLETED = 'caseIntakeCompleted',
  INTERPRETER_NOT_REQUIRED = 'interpreterNotRequired',
  HISTORY_ORDERED = 'historyOrdered',
  RECORD_REVIEW_ORDERED = 'recordReviewOrdered',
  REFERRAL_RECEIVED = 'referralReceived'
}